import React from 'react';
import IDHelpers from '../../../../../../core/helpers/IDHelper';
import ProcedureCard from '../../Cards/Procedure';
import * as S from './styles';

interface IProps {
  procedureList: any[];
  handleSelectProcedure: (procedure: any) => void;
}

const Procedure = ({ procedureList, handleSelectProcedure }: IProps) => {
  const sortedProcedureList = procedureList.sort((a, b) =>
    a.name.localeCompare(b.name)
  );
  return (
    <>
      <S.ProcedureListGrid data-testid="cmp-procedure-list">
        {sortedProcedureList?.length > 0 &&
          sortedProcedureList?.map((procedure: any) => (
            <ProcedureCard
              key={IDHelpers.generateID()}
              onClick={() => {
                handleSelectProcedure(procedure);
              }}
              isNew={procedure.isNew}
              title={procedure.name}
              deadline={procedure.endDate}
              isExternal={procedure.isExternal}
            />
          ))}
      </S.ProcedureListGrid>
    </>
  );
};

export default Procedure;
